import { useTypedDispatch } from "@/redux/helpers/hooks.ts";
import axios from "axios";
import { getUser } from "@/redux/slices/user/thunks/getUser.ts";
import { getCart } from "@/redux/slices/user/thunks/getCart.ts";

const useAddPlan = () => {
  const dispatch = useTypedDispatch();

  return async ({ planId, quantity }: { planId: number; quantity: number }) =>
    await axios
      .post("/svc/cart/plan", {
        plan_id: planId,
        quantity,
      })
      .catch((err) => false)
      .then(async () => {
        return await dispatch(getCart());
      });
};

export default useAddPlan;
